import "../../main.js";
import Alpine from "../../plugins/alpine.js";

import Schema from "async-validator";

const descriptor = {
  name: {
    type: "string",
    required: true,
  },
  email: [
    {
      type: "string",
      required: true,
    },
    {
      type: "string",
      message: "Please enter a valid email address",
      pattern:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    },
  ],
  reviews: {
    type: "string",
    required: true,
  },
};
const validator = new Schema(descriptor);

const submit = (form) =>
  validatorFields(form, () => {
    // success callback
  });

const validatorFields = (form, success) => {
  const { name, email, reviews } = form;
  validator
    .validate({ name, email, reviews })
    .then(() => {
      success?.({ name, email, reviews });
      return true;
    })
    .catch(({ errors, fields }) => {
      form.errors = errors;
      form.fields = fields;
      return false;
    });
};

const getPathName = () => {
  const arr = location.pathname.split("/").filter((item) => !!item);
  return arr[arr.length - 1] ?? "";
};

Alpine.data("submit", submit);
Alpine.data("errors", null);
Alpine.data("fields", null);
Alpine.data("validatorFields", validatorFields);

Alpine.data("category", () => getPathName());

/**
 * himg h标签下图片
 * img p标签下图片
 */
const detailContents = {
  "nd-wire-drawing-die": {
    h: "Natural Diamond Wire Drawing Dies",
    p: [
      "Product Name:ND Wire Drawing Dies; ND Drawing Dies; Diamond Drawing Dies; Natural Diamond Drawing Dies; Diamond Dies; Natural Diamond Dies",
      "Hole Sizes:0.012-2.100(mm); 0.0005-0.0827(inch)",
      "Applications",
      "Advantages:Natural Diamond Drawing Die is made of high quality die core,which has the advantages of uniform texture,strong wear resistance,high finish,high precision and long service life.",
      "Wire drawing is done by passing the metal wire through the hole of the Diamond Wire Drawing Dies, and applying a pulling force to the wire at the exit side of the dies. The wire is contracted and squeezed in the dies cavity and gradually becomes thinner, and its speed increases near the exit of the die hole. Since the volume of the wire is constant, the decrease in cross section makes it stretched. In the center, there is a hole of a certain shape, such as round, square, octagonal or other special shapes. When the metal is pulled through the die hole, the size becomes smaller and even the shape changes.",
      "The best material depends on the wire you draw and the quantity you draw. Contact us to help you choose the most economical solution and reduce the total cost of ownership of your wire drawing dies.:ND Wire Drawing Dies is mainly used for drawing fine and ultra-fine wires,or it is widely used in applications requiring excellent wire surface finish and good heat dissipation performance.",
    ],
    himg: ["/images/1、WIRE DRAW DIES/1、ND WIRE DRAWING DIE .png"],
  },
  "pcd-wire-drawing-die": {
    h: "PCD Wire Drawing Dies",
    p: [
      "Application fields",
      "Electromagnetic wire, brass wire, copper wire, aluminum cable,low carbon, medium carbon steelSuitable for dry and wet drawing.Suitable for high abrasive wire",
      "Product description：PCD wire drawing dies,Polycrystalline diamond dies for ferrous and nonferrous wires.",
      "PCD（Polycrystalline Diamond）is synthetic diamond product. The carbon molecule forms PCD under ultra high temperature and press. Strong bond between diamond particle make PCD have higher abrasive resistance,hardness as well as good thermal conductivity. Moreover, PCD can be easily processed to dies with wider range of diameter ,long life time and high economic benefits.",
    ],
    himg: ["/images/1、WIRE DRAW DIES/2、PCD WIRE DRAWING DIE.png"],
  },
  "tungsten-carbide-wire-drawing-die": {
    h: "TUNGSTEN CARBIDE WIRE DRAWING DIE",
    p: [
      "Tungsten carbide drawing dies made to your quality requirements allow you to meeting quality, uptime and speed standards.",
      "TC drawing dies are manufactured with a mirror polish and a smooth wire entry to ensure optimal die life and string-up.",
      "Wire drawing dies are commonly used to reduce the diameter of various ferrous and non-ferrous rods and wires. Applications include various grades of low, medium and high carbon steels, steel alloys, stainless steel, welding wire as well as various non-ferrous rods and wires.",
      "BENEFITS:",
      "Ideal for ferrous rod-size wire",
      "Ideal for short and trial runs",
      "Carbide grade tailored to wire material when required",
      "Special coatings available to reduce friction and/or increase durability",
      "Cast & helix control available",
      "KEY FEATURES:",
      "Usable for dry and wet draw",
      "Custom case sizes available",
      "Various carbide grades available",
    ],
    himg: ["/images/1、WIRE DRAW DIES/3.TUNGSTEN CARBIDE WIRE DRAWING DIE.jpg"],
  },
  "nano-coating-drawing-die": {
    h: "Nano Diamond Coating Dies",
    p: [
      'Diameter:1.2mm~60.0mm (0.047"~2.362")',
      "Coating: Chemical vapor deposition CVD",
      'Product description：Nano Diamond Coating Dies from 0.047" to 2.362" for kinds of wires.',
      "Nano dies have unique nanocrystalline diamond composite structures(chemical vapor deposition CVD ) to achieve significant productivity improvements.The diamond coating makes nano dies exceptional in durability and smoothness.",
      "Appliable Wires:",
      "Copper,aluminum,brass,aluminum,alloys,low-high carbon and stainless steel wires and tubes.",
      "Features of Nano Diamond Coating Dies:",
      "High cost performance.",
      "High production efficiency.",
      "Low friciton.",
      "Bright wire surface.",
      "No wear ring and scratch.",
      "Very hard die surface.",
      "Free of die recutting.",
    ],
    himg: ["/images/1、WIRE DRAW DIES/4、Nano Coating Drawing Die.png"],
  },
  "pcd-stranding-dies": {
    h: "PCD Stranding Dies",
    p: [
      'Diameter : 0.1mm ~ 29.0mm (0.00315" ~1.1417")',
      "Grain size :3um,5um,10um,25um,50um",
      "Wires:Copper ,aluminum,copper clad aluminum,copper clad steel",
      "Product description：PCD stranding (bunching) dies for ferrous and nonferrous wires.",
    ],
    himg: ["/images/1、WIRE DRAW DIES/5、PCD Stranding Dies.png"],
  },
  "sector-stranding-die": {
    h: "",
    p: [
      "Application fields：",
      "Flexible wire, mild steel:Aluminum, copperand other non-ferrous cable, dry-drawing ofsteel and stainless steel, welding wiredrawing and tube drawing",
    ],
    himg: ["/images/1、WIRE DRAW DIES/6、Sector Stranding Die.png"],
  },
  "tubing-dies": {
    h: "Dies for tube manufacturing",
    p: [
      "MAIN FEATURE：",
      "Made to spec to ensure wall thickness",
      "Tight dimension tolerances",
      "Die geometry engineering available",
      "Available in TC, PCD, SSCD and ND",
      "Starting from 0,007 to 100 mm",
      "High performance tubing dies allow tube manufacturers to meet surface quality and dimension standards.",
      "Wire drawing dies are commonly used to reduce the diameter of various ferrous and non-ferrous rods and tubes. Applications include automotive, medical wire, superconducting, and welding wires.",
    ],
    himg: ["/images/1、WIRE DRAW DIES/7、Tubing Dies.png"],
  },
  "special-shaped-dies": {
    h: "Make wire in any shape",
    p: [
      "MAIN FEATURE：",
      "Gradually morph from one shape to another",
      "Small dimensional tolerance",
      "Can carry out engineering design for module sets",
      "Can use TC, PCD, SSCD and ND materials",
      "Specifications start from 0.1 mm",
      "High-performance forming dies enable wire drawing manufacturers to meet various surface quality and dimensional standards for wire drawing.",
      "The forming die can reduce the diameter or change from one drawn shape to another. Applications include various types of black and colored rods and wires. WE can be customized to your requirements and can have virtually any bore shape. Shapes include trapezoid, rectangle, rod, hexagon, Z-shape, square, triangle, trapezoid, oval, semicircle, triangle, various shapes for transmission cables and overhead lines (almost any shape can be provided) .",
      "We can help you engineer a range of molds, gradually changing from round lines or profiles or rods to another shape. Please inform us of your profile rod or profile requirements and our engineering team will be happy to design a product series that suits you.",
      "Our drawing dies are mirror-polished during manufacture, and the wire feed device is very smooth, ensuring optimal mold service life and drawing results.",
    ],
    himg: ["/images/1、WIRE DRAW DIES/8、Special-shaped Dies.png"],
  },
  "split-stranding-dies": {
    h: "Split Stranding Dies",
    p: [
      "Made in a wide range of configurations and designs, split dies can dramatically cut your setup time by eliminatingthe need to restring a stranding or cabling machine when changing sizes.Split dies allow for quick changeovers without cutting the wire, providing ease of use and higher throughput",
    ],
    himg: ["/images/1、WIRE DRAW DIES/9 Split Stranding Dies.png"],
  },
  "extrusion-tips": {
    h: "Extrusion Tips",
    p: [
      "Extrusion tools are commonly used to apply an insulating layer around a solid or stranded wire.",
      "The extrusion tip, also called extrusion wire guide, guides a single or group of wires into and through an extrusion die.",
      'State-of-the-art technology and tight concentricity (.0002""/0.005 mm) of extrusion tools give the insulator the ability to maintain a uniform insulation thickness minimizing material usage and scrap.',
      "Super-hard material inserts in the wire guides, primarily diamond and carbide, ensure long tool life even at high extrusion process speeds.",
      "Benefits",
      "Insulation material savings",
      "Superior concentricity capabilities",
      "Wire perfectly centered within insulation material。",
      "Custom tip and die manufacturing available, turning your ideas into reality",
      "Types of wire extrusion diamond dies and Wire guides/tips:",
      "1.Solid tungsten carbide",
      "2.Steel with heat treated",
      "3.Steel body with tungsten carbide insert",
      "4.Steel body with PCD diamond inserts",
    ],
    himg: [
      "/images/2、Extrusion Tools And Wire Guide/56.png",
    ],
  },
  "extrusion-dies": {
    h: "Extrusion Dies",
    p: [
      "Extrusion tools are commonly used to apply an insulating layer around a solid or stranded wire.",
      "The extrusion tip, also called extrusion wire guide, guides a single or group of wires into and through an extrusion die.",
      'State-of-the-art technology and tight concentricity (.0002"/0.005 mm) of extrusion tools give the insulator the ability to maintain a uniform insulation thickness minimizing material usage and scrap.',
      "Super-hard material inserts in the wire guides, primarily diamond and carbide, ensure long tool life even at high extrusion process speeds.",
      "Benefits",
      "Insulation material savings",
      "Superior concentricity capabilities",
      "Wire perfectly centered within insulation material。",
      "Custom tip and die manufacturing available, turning your ideas into reality",
      "Types of wire extrusion diamond dies and Wire guides/tips:",
      "1.Solid tungsten carbide",
      "2.Steel with heat treated",
      "3.Steel body with tungsten carbide insert",
      "4.Steel body with PCD diamond inserts",
    ],
    himg: ["/images/2、Extrusion Tools And Wire Guide/5.png"],
  },
  "nail-cutting-knife": {
    h: "Nail cutting knife",
    p: [
      "Cutting knives are available with both brazed and interchangeable tungsten carbide insert .",
      "We manufacture all types of knives.Cutting knives are manufactured according to customers demand for wire dimension and shape of the nail head.",
      "Application Fields ：",
      "Round nail, cement nail, shot nail, ordinary iron nail, corrugated nail, screw nail, hemp nail, dry wall nail, felt nail, floor nail, shoe nail, etc",
    ],
    himg: ["/images/4、nail dies/1、Nail cutting knife.png"],
    img: ["/images/4、nail dies/1.png"],
  },
  "nail-gripper-die": {
    h: "Nail gripper die",
    p: [
      "Dies are available with both brazed and interchangeable tungsten carbide insert . We supply exchangeable inserts both round or square.",
      "Application Fields ：",
      "Round nail, cement nail, shot nail, ordinary iron nail, corrugated nail, screw nail, hemp nail, dry wall nail, felt nail, floor nail, shoe nail, etc",
    ],
    himg: ["/images/4、nail dies/2、Nail gripper die.png"],
    img: ["/images/4、nail dies/2.png"],
  },
  "nail-head-punch": {
    h: "Nail head punch",
    p: [
      "Our punches are manufactured in full tungsten carbide and brazed. The punches come with a plain or grooved surface as standard.Other profiles can be custom made on request.",
    ],
    himg: ["/images/4、nail dies/3、Nail head punch.jpg"],
    img: ["/images/4、nail dies/3.png"],
  },
  "tungsten-carbide-roller-for-welded-wire-mesh": {
    h: "Tungsten carbide roller for welded wire mesh",
    p: [
      "Tungsten carbide wire mesh rollers are used to produce smooth or ribbed wire for the construction reinforcement.",
      "TTW company produces notches and profiles in accordance to any International standard",
      "Identification marking on the rollers with your request",
      "TTW company provide regrinding and repairing service",
    ],
    himg: [
      "/images/3、tungsten carbide roll/1、Tungsten carbide roller for welded wire mesh.jpg",
    ],
    img: [
      "/images/3、tungsten carbide roll/3.png",
      "/images/3、tungsten carbide roll/1.png",
      "/images/3、tungsten carbide roll/2.png",
    ],
  },
  "roller-holders-and-colling-pins": {
    h: "ROLLER HOLDERS AND COLLING PINS",
    p: [],
    himg: [
      "/images/3、tungsten carbide roll/2、ROLLER HOLDERS AND COLLING PINS.png",
    ],
  },
  "descaling-rolls": {
    h: "DESCALING ROLLS/WIRE GUIDE ROLLS/GUIDE DIES",
    p: [
      "Wire descaling roller",
      "We produce wire descaling roll, wire straightening roll, wire guide roll and stress relieving roll",
      "Wire descaling rolls are used for removing and cleaning wire surface with ideal properties for further processing",
      "Straightening rolls used on straightening machines to produce “Z” , “L”, “T”, and hot rolled angles.",
      "Stress relieving rolls are made of tungsten carbide to improve the mechanical characteristics of the cold rolled wire.",
    ],
    himg: ["/images/3、tungsten carbide roll/3.DESCALING ROLLS.png"],
  },
  "seaming-roller": {
    h: "Seaming roller",
    p: [],
    himg: ["/images/3、tungsten carbide roll/4、Seaming roller.png"],
  },
  "flat-dies": {
    h: "Flat Dies",
    p: [
      "Flat Dies (Flat thread-rolling dies) are used for the manufacture of metric and inch threads in structural steel products, such as bolts, self-tapping screws, and screws. The flat dies system has two die flats (a stationary die and a moving die), the bottom one is held stationary and the other slides. The workpiece is placed on one end of the stationary die then the moving die slides over the workpiece, which causes the workpiece to roll off the stationary lower die in a finished form.",
      "Flat thread rolling dies are available in various thread forms such as ANSI, BS, DIN, JIS, etc. It can be offered with or without holding angles. Flat dies produce external threads by the process of cold forming, utilizing one stationary and one moving die to form the threads.",
      "Materials mainly included Cr12MoV, DC53 and high speed tool steel. Threads are made by rolling, grinding or milling. Flat thread rolling dies with precision class 1, 2 or 3 can be manufactured.",
      "Flat thread rolling dies are produced with excellent heat treatment and are truly durable. The hardness of the die after heat treatment is 63HRC. Under normal operating conditions, the average service life of one set of flat dies exceeds 2 million pieces.",
    ],
    himg: ["/images/5、Dies for fasteners/1、Flat Dies.jpg"],
  },
  "cold-heading-dies": {
    h: "Cold heading dies",
    p: [
      "Cold heading dies also called tungsten carbide punching, cold forming dies, or heading dies. It is compressed by powder metallurgy, with high hardness, high-strength cemented carbide dies, as an important working component of cold heading machine, completes punching, bending, stretching, etc., and is widely used in the field of production and processing.",
    ],
    himg: [
      "/images/5、Dies for fasteners/2、Cold heading dies.png",
    ],
  },
  "threading-rolling-dies": {
    h: "Threading rolling dies",
    himg: ["/images/5、Dies for fasteners/3、Threading rolling dies.png"],
  },
  "stamping-dies": {
    h: "Stamping dies",
    himg: ["/images/5、Dies for fasteners/4、Stamping dies.png"],
  },
  "cold-forming-trimming-die": {
    h: "Cold heading dies",
    p: [
      "Cold heading dies also called tungsten carbide punching, cold forming dies, or heading dies. It is compressed by powder metallurgy, with high hardness, high-strength cemented carbide dies, as an important working component of cold heading machine, completes punching, bending, stretching, etc., and is widely used in the field of production and processing.",
    ],
    himg: [
      "/images/5、Dies for fasteners/5、Cold Forming Trimming Die.png",
    ],
  },
  "punch-cutter": {
    h: "PUNCH CUTTER",
    himg: ["/images/5、Dies for fasteners/6、PUNCH CUTTER.png"],
  },
};

const productListMap = {
  "wire-draw-dies": [
    {
      title: "ND WIRE DRAWING DIE",
      link: "/product/nd-wire-drawing-die",
      image: "/images/1、WIRE DRAW DIES/1、ND WIRE DRAWING DIE .png",
    },
    {
      title: "PCD WIRE DRAWING DIE",
      link: "/product/pcd-wire-drawing-die",
      image: "/images/1、WIRE DRAW DIES/2、PCD WIRE DRAWING DIE.png",
    },
    {
      title: "TUNGSTEN CARBIDE WIRE DRAWING DIE",
      link: "/product/tungsten-carbide-wire-drawing-die",
      image:
        "/images/1、WIRE DRAW DIES/3.TUNGSTEN CARBIDE WIRE DRAWING DIE.jpg",
    },
    {
      title: "Nano Coating Drawing Die",
      link: "/product/nano-coating-drawing-die",
      image: "/images/1、WIRE DRAW DIES/4、Nano Coating Drawing Die.png",
    },
    {
      title: "PCD Stranding Dies",
      link: "/product/pcd-stranding-dies",
      image: "/images/1、WIRE DRAW DIES/5、PCD Stranding Dies.png",
    },
    {
      title: "Sector Stranding Die",
      link: "/product/sector-stranding-die",
      image: "/images/1、WIRE DRAW DIES/6、Sector Stranding Die.png",
    },
    {
      title: "Tubing Dies",
      link: "/product/tubing-dies",
      image: "/images/1、WIRE DRAW DIES/7、Tubing Dies.png",
    },
    {
      title: "Special-shaped Dies",
      link: "/product/special-shaped-dies",
      image: "/images/1、WIRE DRAW DIES/8、Special-shaped Dies.png",
    },
    {
      title: "Split Stranding Dies",
      link: "/product/split-stranding-dies",
      image: "/images/1、WIRE DRAW DIES/9 Split Stranding Dies.png",
    },
  ],
  "extrusion-tools-and-wire-guide": [
    {
      title: "Extrusion Tips",
      link: "/product/extrusion-tips",
      image: "/images/2、Extrusion Tools And Wire Guide/56.png",
    },
    {
      title: "Extrusion Dies",
      link: "/product/extrusion-dies",
      image: "/images/2、Extrusion Tools And Wire Guide/5.png",
    },
  ],
  "nail-dies": [
    {
      title: "Nail cutting knife",
      link: "/product/nail-cutting-knife",
      image: "/images/4、nail dies/1、Nail cutting knife.png",
    },
    {
      title: "Nail gripper die",
      link: "/product/nail-gripper-die",
      image: "/images/4、nail dies/2、Nail gripper die.png",
    },
    {
      title: "Nail head punch",
      link: "/product/nail-head-punch",
      image: "/images/4、nail dies/3、Nail head punch.jpg",
    },
  ],
  "tungsten-carbide-roll": [
    {
      title: "Tungsten carbide roller for welded wire mesh",
      link: "/product/tungsten-carbide-roller-for-welded-wire-mesh",
      image:
        "/images/3、tungsten carbide roll/1、Tungsten carbide roller for welded wire mesh.jpg",
    },
    {
      title: "ROLLER HOLDERS AND COLLING PINS",
      link: "/product/roller-holders-and-colling-pins",
      image:
        "/images/3、tungsten carbide roll/2、ROLLER HOLDERS AND COLLING PINS.png",
    },
    {
      title: "DESCALING ROLLS",
      link: "/product/descaling-rolls",
      image: "/images/3、tungsten carbide roll/3.DESCALING ROLLS.png",
    },
    {
      title: "Seaming roller",
      link: "/product/seaming-roller",
      image: "/images/3、tungsten carbide roll/4、Seaming roller.png",
    },
  ],
  "dies-for-fasteners": [
    {
      title: "Flat Dies",
      link: "/product/flat-dies",
      image: "/images/5、Dies for fasteners/1、Flat Dies.jpg",
    },
    {
      title: "Cold heading dies",
      link: "/product/cold-heading-dies",
      image: "/images/5、Dies for fasteners/2、Cold heading dies.png",
    },
    {
      title: "Threading rolling dies",
      link: "/product/threading-rolling-dies",
      image: "/images/5、Dies for fasteners/3、Threading rolling dies.png",
    },
    {
      title: "Stamping dies",
      link: "/product/stamping-dies",
      image: "/images/5、Dies for fasteners/4、Stamping dies.png",
    },
    {
      title: "Cold Forming Trimming Die",
      link: "/product/cold-forming-trimming-die",
      image: "/images/5、Dies for fasteners/5、Cold Forming Trimming Die.png",
    },
    {
      title: "PUNCH CUTTER",
      link: "/product/punch-cutter",
      image: "/images/5、Dies for fasteners/6、PUNCH CUTTER.png",
    },
  ],
};

const setParentKey = () => {
  for (const [key, value] of Object.entries(productListMap)) {
    value.forEach((item) => {
      const detailKey = item.link.substring(item.link.lastIndexOf("/") + 1);
      if (Object.prototype.hasOwnProperty.call(detailContents, detailKey)) {
        detailContents[detailKey].parentKey = key;
      }
    });
  }
};

setParentKey();

const getProductList = (key) => {
  const parentKey = detailContents[key].parentKey;
  return productListMap[parentKey].filter(
    (item) => item.link.substring(item.link.lastIndexOf("/") + 1) !== key
  );
};

// 当前详细
Alpine.data("detail", () => detailContents[getPathName()]);

// 相关产品
Alpine.data("productList", () => getProductList(getPathName()) || []);

Alpine.start();
